import {__} from '@wordpress/i18n';
import {CONFIG} from '../../../globals/config';
import {SelectControl} from '@wordpress/components';
import type {Attr, SetAttributes} from './Edit';
import {entriesOf} from '../../../globals/helpers';

export type OrderOptions = {
	order: 'ASC' | 'DESC';
}

type Props = {
	attributes: OrderOptions;
	setAttributes: SetAttributes;
}

const Order = ( {attributes, setAttributes}: Props ) => {
	return (
		<SelectControl<Attr['order']>
			label={__( 'Order', 'advanced-sidebar-menu' )}
			value={attributes.order}
			labelPosition={'side'}
			options={entriesOf( CONFIG.pages.order ).map( ( [ value, label ] ) => ( {
				value,
				label,
			} ) )}
			onChange={value => {
				setAttributes( {
					order: value,
				} );
			}} />
	);
};

export default Order;
